<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ProductBookingFieldsMixin extends Vue {
        isProductFieldMandatory(fieldKey) {
            return this.productBookingFields?.[fieldKey] === 'MANDATORY'
        }

        isProductFieldDisabled(fieldKey) {
            return this.productBookingFields?.[fieldKey] === 'DISABLED'
        }

        productFieldLabel(token, fieldKey) {
            return this.isProductFieldMandatory(fieldKey) ? `${this.$t(token)}*` : `${this.$t(token)}`
        }

        get productBookingFields() {
            return runtimeStore.productBookingFields
        }
    }

    export default ProductBookingFieldsMixin
</script>
